export default "/images/star-filled.svg?0dd20e0a803d51d082c93fe10e727f99";